import React, { useState } from 'react';
import skillData from '../skills/skillData.json';

const SkillButton = () => {
    const [appState, changeState] = useState({
        activeObject: skillData[0],
        objects: skillData
    });
    const toggleActive = (index) => {
        changeState({ ...appState, activeObject: appState.objects[index] })
    }
    const toggleActiveStyles = (index) => {
        if (appState.objects[index] === appState.activeObject) {
            return "backdrop-blur bg-white/10"
        }
        else {
            return ""
        }
    }
    const SkillButtons = skillData.map((data, index) => (
        <div className='grid justify-center' key={data.id}>
            <div className={`h-[14vmin] w-[14vmin] rounded-2xl grid items-center justify-center ${toggleActiveStyles(index)}`} onClick={() => {
                toggleActive(index);
            }} >
                <img className='h-[8vh]' src={data.logo} alt='' />
            </div>
        </div>
    ));


    return SkillButtons;
};

export default SkillButton;
